import { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import options from "../../variables/particle.json";
import { TypeAnimation } from 'react-type-animation';
// reactstrap components
import { Container, Button } from "reactstrap";
import i18n from "../../utils/lang/i18n";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export default function PageHeader() {
  const [ init, setInit ] = useState(false);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    initParticlesEngine(async (engine) => {
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadAll(engine);
        //await loadFull(engine);
        await loadSlim(engine);
        //await loadBasic(engine);
    }).then(() => {
        setInit(true);
    });    
}, []);

    const particlesLoaded = (container) => {
        //console.log(container);
    };


  return (
    <div className="page-header header-filter">
      <div className="squares square1" />
      <div className="squares square2" />
      <div className="squares square3" />
      <div className="squares square4" />
      <div className="squares square5" />
      <div className="squares square6" />
      <div className="squares square7" />
      <Container>
  
        <div className="content-center-home brand">
          <div className="-space-x-3">
            <img 
              alt="Avatar 01" 
              loading="lazy" 
              width="32" 
              height="32"
              decoding="async" 
              data-nimg="1" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-01.webp")}/>
            <img 
              alt="Avatar 02" 
              loading="lazy" 
              width="32" 
              height="32" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-02.webp")}/>
            <img 
              alt="Avatar 03" 
              loading="lazy" 
              width="32" 
              height="32" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-03.webp")}/>          
            <img 
              alt="Avatar 04" 
              loading="lazy" 
              width="32" 
              height="32" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-04.webp")}/>          
            <img 
              alt="Avatar 05" 
              loading="lazy" 
              width="32" 
              height="32" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-05.webp")}/>          
            <img 
              alt="Avatar 06" 
              loading="lazy" 
              width="32" 
              height="32" 
              className="img-fluid rounded-circle shadow-lg border border-2"
              src={require("assets/img/avatar-06.webp")}/>          
          </div>          
          <div
            style={{
              fontSize: '4em',
              color: "#FFF",
            }}
          >
            <TypeAnimation
              sequence={[
                t('GenerationS'),
                1000,
                t('A strong church'),
                1000,
                t('We are connected!'),
                1000,
              ]}
              key={i18n.language}
              speed={50}
              style={{color: "#bb35dd"}}
              repeat={Infinity}
            />
          </div>
          <Button className="btn-round" color="primary" type="button" href="/seja-membro">
              <i className="tim-icons icon-heart-2" /> <Trans>Become a member</Trans>
          </Button>        
        </div>
      </Container>
      <Particles
        particlesLoaded={particlesLoaded}
        style={{
          position: 'absolute'
        }}
        id='tsparticles'
        init={init}
        options={options}
        height='100vh'
        width='100vw'
      ></Particles>
    </div>
  );
}
